import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import axios from "axios";
import GeneratedQuestions from "./vdfndr_generated_questions";

const RegeneratedQuestions = forwardRef(({ id }, ref) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const timeoutRef = useRef(null);

  const loadData = async () => {
    try {
      setLoading(true);
      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/video-finder-transcript-summary?id=${id}`
      );
      if (data?.data?.every((el) => el.status === "VALIDATION_COMPLETED")) {
        setLoading(false);
        setData(data.data);
        clearTimeout(timeoutRef.current);
      } else {
        timeoutRef.current = setTimeout(loadData, 5000);
      }
    } catch (err) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!id) return;
    loadData();
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [id]);

  useImperativeHandle(ref, () => ({
    loadData,
  }));

  if (loading) return <div className="mt-4">Loading...</div>;
  if (!data) return <div className="mt-4">No questions found.</div>;

  return (
    <div className="mt-4">
      <GeneratedQuestions id={id} />
    </div>
  );
});

export default RegeneratedQuestions;
